import React from "react";
import { BookOpen } from "lucide-react";

/**
 * Persistent left sidebar for desktop: shows Matthew chapter list.
 */
export default function ChapterSidebar({ chapters, current, onSelect }) {
    return (
        <aside
            data-testid="chapter-sidebar"
            className="hidden lg:flex flex-col w-[220px] xl:w-[280px] shrink-0 h-screen sticky top-0 border-r border-ink-10 bg-sage-paper/60"
        >
            <div className="px-6 pt-8 pb-4">
                <div className="flex items-center gap-2 text-moss-deep">
                    <BookOpen size={16} />
                    <span className="font-ui text-[11px] uppercase tracking-[0.22em]">
                        The Gospel of
                    </span>
                </div>
                <div className="scripture text-3xl text-ink mt-1 tracking-tight">
                    Matthew
                </div>
                <div className="font-ui text-xs text-ink-40 mt-1">
                    28 chapters
                </div>
            </div>

            <div className="px-4 pb-8 overflow-y-auto sheet-scroll flex-1">
                <div className="grid grid-cols-5 gap-1.5">
                    {chapters.map((c) => (
                        <button
                            key={c.chapter}
                            data-testid={`sidebar-chapter-${c.chapter}`}
                            onClick={() => onSelect(c.chapter)}
                            className={
                                "h-10 rounded-lg font-ui text-[13px] font-medium transition-all " +
                                (c.chapter === current
                                    ? "bg-moss text-white shadow-sm"
                                    : "text-ink-70 hover:bg-moss/10 hover:text-moss-deep")
                            }
                            aria-current={c.chapter === current ? "page" : undefined}
                        >
                            {c.chapter}
                        </button>
                    ))}
                </div>
            </div>

            <div className="px-6 py-5 border-t border-ink-10">
                <p className="font-ui text-[10px] leading-relaxed text-ink-40">
                    Scripture: KJV (public domain). Lexical data from{" "}
                    <a href="https://stepbible.org" target="_blank" rel="noreferrer noopener"
                       className="underline decoration-ink-10 hover:decoration-moss">
                        STEPBible.org
                    </a>, CC BY 4.0. WEB also available.
                </p>
            </div>
        </aside>
    );
}
